/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";

const ContactInfo = () => {
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("first_name", values.firstName);
      formData.append("last_name", values.lastName);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("subject", values.subject);
      formData.append("message", values.message);

      axiosInstance
        .post("/contact", formData)
        .then((response) => {
          if (response?.data?.status) {
            toast.success(
              response?.data?.message || "Message Send Successfully."
            );
            formik.resetForm();
          }
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
        });
    },
  });

  return (
    <div className="contact_form_area">
      <div className="row align-items-center">
        <div
          className="col-xl-5 col-md-6 col-lg-5 wow fadeInUp"
          data-wow-duration="1s"
        >
          <div className="contact_info_area">
            <div className="contact_info">
              <h3>call</h3>
              <p>
                <a href="tel:(509)601-2505"> (509)601-2505</a>
              </p>
            </div>
            <div className="contact_info">
              <h3>E-mail</h3>
              <p>
                <a href="mailto:info@afrikanbbq.com"> info@afrikanbbq.com</a>
              </p>
              <p>
                <a href="mailto:afrikanbbq@gmail.com">afrikanbbq@gmail.com</a>
              </p>
            </div>
            <div className="contact_info border-0 p-0 m-0">
              <h3>location</h3>
              <p>3118 E Baldwin Ave Spokane, WA 99207</p>
            </div>
          </div>
        </div>
        <div
          className="col-xl-7 col-md-6 col-lg-7 wow fadeInUp"
          data-wow-duration="1s"
        >
          <form className="contact_form" onSubmit={formik.handleSubmit}>
            <h3>contact us</h3>
            <div className="row">
              <div className="col-xl-6">
                <div className="contact_form_input">
                  <span>
                    <i className="fas fa-user" />
                  </span>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.firstName && formik.errors.firstName && (
                    <div className="text-red">{formik.errors.firstName}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="contact_form_input">
                  <span>
                    <i className="fas fa-user" />
                  </span>
                  <input
                    type="text"
                    placeholder="Last Name"
                    name="lastName"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.lastName && formik.errors.lastName && (
                    <div className="text-red">{formik.errors.lastName}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="contact_form_input">
                  <span>
                    <i className="fas fa-envelope" />
                  </span>
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-red">{formik.errors.email}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="contact_form_input">
                  <span>
                    <i className="fas fa-phone-alt" />
                  </span>
                  <input
                    type="text"
                    placeholder="Phone"
                    name="phone"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.phone && formik.errors.phone && (
                    <div className="text-red">{formik.errors.phone}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-12">
                <div className="contact_form_input">
                  <span>
                    <i className="fas fa-book" />
                  </span>
                  <input
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.subject && formik.errors.subject && (
                    <div className="text-red">{formik.errors.subject}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-12">
                <div className="contact_form_input textarea">
                  <span>
                    <i className="fas fa-pen" />
                  </span>
                  <textarea
                    rows={5}
                    placeholder="Message"
                    name="message"
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {/* Display error message if the field is invalid */}
                  {formik.touched.message && formik.errors.message && (
                    <div className="text-red">{formik.errors.message}</div>
                  )}
                </div>
                <button className="common_btn" type="submit">
                  send message
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
